import * as Yup from "yup";
export const FirmaKorrespondanceForm = (
  firmaId: string,
  firmaKorrespondanceId?: string,
): FormConfig<FirmaKorrespondanceDTO> => {
  return {
    title: "FirmaKorrespondance",
    lockedValues: [
      { id: "firmaId", value: firmaId },
      { id: "firmaKorrespondanceId", value: firmaKorrespondanceId },
    ],
    form: [
      {
        component: "datepicker",
        id: "opretDato",
        label: "Oprettet dato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "beskrivelse",
        label: "Beskrivelse",
        initialValue: "",
      },
      {
        component: "textinput",
        id: "filnavn",
        label: "Filtype",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "opretInit",
        label: "Oprettet af",
        initialValue: "",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      opretDato: Yup.date().nullable().required("Oprettet dato skal være sat"),
      beskrivelse: Yup.string(),
      filnavn: Yup.string().required("Filnavn skal være sat"),
      opretInit: Yup.string().required("Oprettet af skal være sat"),
    }),
    get: `firma/${firmaId}/korrespondancer/${firmaKorrespondanceId}`,
    getDocument: `firma/${firmaId}/korrespondancer/${firmaKorrespondanceId}/dokument`,
    downloadLink: `firma/${firmaId}/korrespondancer/${firmaKorrespondanceId}/download`,
    delete: () => {
      return {
        query: `firma/${firmaId}/korrespondancer/${firmaKorrespondanceId}`,
      };
    },
  };
};
